import { removeListingItem, setListingItem } from './storage';

// The abandoned cart email lands on /recapture/{token}, which rebuilds the buyer's cart as a new
// reservation and redirects here with #/checkout/{token}?secret=…&eventId=…. The checkout only
// resumes a reservation stored for the listing, so store it as if this browser had created it,
// then take the secret out of the address bar before anything reports the URL.
export function adoptReservationFromUrl(listingSlug) {
  const match = window.location.hash.match(/^#\/checkout\/([a-f0-9]+)\?(.*)$/);
  const params = new URLSearchParams(match ? match[2] : '');
  const secret = params.get('secret');
  if (!secret) {
    return false;
  }
  const token = match[1];

  setListingItem(listingSlug, 'token', token);
  setListingItem(listingSlug, 'secret', secret);
  // a series listing restores the carted session only from here; a single event clears any
  // session an earlier visit left behind
  const eventId = Number(params.get('eventId'));
  if (eventId) {
    setListingItem(listingSlug, 'selectedEventId', eventId);
  } else {
    removeListingItem(listingSlug, 'selectedEventId');
  }
  // left by an earlier order on this listing, it would open that confirmation instead
  removeListingItem(listingSlug, 'confirmation');
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#/checkout/${token}`);
  return true;
}
